import React from 'react'
import SamPhoto from '../images/Sam_Ottow_Founder.png'
import MattPhoto from '../images/Matt_Beck_Founder.png'
import TrevorPhoto from '../images/Trevor_Mills_Founder.png'
import JoshPhoto from '../images/Josh_St_Marie_Founder.png'
import SpencerLogo from '../images/Logo - SpencerKabelacProductions_white.png'
import MiLenteLogo from '../images/MiLenteLogo.png'
import RealRefReportLogo from '../images/real_ref_report_logo.png'
import Westbrook_Image from '../images/WESTBROOK_LOGO.png'


import AdditionalLinksBackground from '../images/Additional_Links_Background.png'
import { Link,useNavigate, useLocation } from 'react-router-dom'

const WWNTeam = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const genderSet = location.pathname.split("/");
    const genderId = genderSet[2];


  return (
    <div class="WWNTeam_div">
        <div className="team_founders">
            <h1>Meet the Team</h1>
            <div className="founder_row">
                <div className="one_founder" style={{backgroundImage: `url(${AdditionalLinksBackground})`,}} >
                    <img className="founder_photo" src={SamPhoto} alt="" />
                    <h3>Sam Ottow</h3>
                    <p>- Snohomish HS graduate</p> 
                    <p>- 2002 bantam state champ at 50 lbs</p>
                    <p>- 4x state placer, 3x finalist</p>
                    <p>- 2009 state champ</p>
                    <p>- Highline College starter in 2010 and 2012</p>
                    <p>- Coached individual state champions at Cedarcrest HS and Glacier Peak HS </p>
                    <p>- Husband, father of 2 girls</p>
                    <p>- Resident of Mukilteo, WA </p>
                    <p>- Interests: Golf, fly fishing, traveling, sports</p>
                </div>
                <div className="one_founder" style={{backgroundImage: `url(${AdditionalLinksBackground})`,}}>
                    <img className="founder_photo" src={MattPhoto} alt="" />
                    <h3>Matt Beck</h3>
                    <p>Thank you so much for caring enough to find our About Us page. It is so nice to meet you and have your support. My name is Matt Beck. I graduated from Everett High School in 2007 and placed 3rd at state. I have a beautiful 10 year old daughter Kinsley (who is my entire world), and I have the pleasure of giving back to my Alma Mater as I coach for Everett High Currently. Although I did not grab a state title in my time wrestling for the Seagulls, I accomplished all of my goals. Wrestling taught me so much, lessons learned that you just wouldn't understand unless you were a wrestler. The amount of hard work and determination it takes to get through the season(s) is why we do this for the community that is the sport of wrestling in Washington state. We wanted to come together to celebrate the effort of those involved... Welcome to the Washington Wrestling Network. Please enjoy, and do not hesitate to reach out if you feel you deserve more attention. We want to hear from you, and we are in this together! </p>
                </div>
            </div>
            <div className="founder_row">
                <div className="one_founder" style={{backgroundImage: `url(${AdditionalLinksBackground})`,}}>
                    <img className="founder_photo" src={TrevorPhoto} alt="" />
                    <h3>Trevor Mills</h3>
                    <p>- Todd Beamer High School Alumni C/O 2009</p>
                    <p>- 3x State Placer. 1x State Finalist</p>
                    <p>- 2x Fargo National participant</p>
                    <p>- Pac-Coast Champ</p>
                    <p>- Assistant Coach @ Kamiak HS</p>
                    <p>- Dog dad, UW fan and habitual golfer</p>
                </div>
                <div className="one_founder" style={{backgroundImage: `url(${AdditionalLinksBackground})`,}}>
                    <img className="founder_photo" src={JoshPhoto} alt="" />
                    <h3>Josh St Marie</h3>
                    <p>- Glacier Peak Alumni</p>
                    <p>- Berklee College of Music</p>
                    <p>- 2011 State Champ</p>
                    <p>- Head Coach | GPHS Girls Wrestling</p>
                    <p>- Father to 3 daughters</p>
                </div>
            </div>
        </div>
        <div className="team_affiliates">
            <h2>WWN Affiliates</h2>
            <div className="one_affiliate" style={{backgroundImage: `url(${AdditionalLinksBackground})`,}}>
                <h3>Andy Aichele | Real Ref Report</h3>
                <img className="affiliate_logos" src={RealRefReportLogo} alt="" />
            </div>
            <div className="one_affiliate" style={{backgroundImage: `url(${AdditionalLinksBackground})`,}}>
                <h3>Spencer Kabelac | Videography</h3>
                <img className="affiliate_logos" src={SpencerLogo} alt="" />
            </div>
            <div className="one_affiliate" style={{backgroundImage: `url(${AdditionalLinksBackground})`,}}>
                <h3>Dee Torres | Mi Lente Photography</h3>
                <img className="affiliate_logos" src={MiLenteLogo} alt="" />
            </div>
        </div>
        <div className="team_sponsors">
            <h2>Sponsors</h2>
            <div className="one_sponsor"  style={{backgroundImage: `url(${AdditionalLinksBackground})`,}}>
                <img className="sponsor_logo" src={Westbrook_Image} alt="" />
            </div>

        </div>
    </div>
  )
}
export default WWNTeam

